import Request from '../modules/request.js'


const handlerStatuscode = (statusCode, data) => {
  console.log(statusCode);
  switch (statusCode) {
    case 200:
      document.getElementById('data-content').innerHTML = data;
      break;
    case 401:
      console.log(statusCode);
      break;
    default:
      console.log(`O CODIGO DE RESPOSTA É: ${statusCode}`);
  }
}
export default class Dashboard {
  #exec_delete;
  constructor() {
    this.current_page = null;
    this.#exec_delete = false;
  }

  set exec_del(val) {
    this.#exec_delete = val;
  }

  get exec_del() {
    return this.#exec_delete;
  }


  setCurrentPage(pageid) {
    const page = document.getElementById(pageid);
    if (this.current_page == null) {
      page.classList.add('active');
      this.current_page = page;
    }

    if (this.current_page != null && this.current_page.id != pageid) {
      this.current_page.classList.remove('active');
      page.classList.add('active');
      this.current_page = page;
    }
  }

  getCustomers(url) {
    this.setCurrentPage('customers');
    const request = new Request();
    request.get(url, (request, response) => {
      handlerStatuscode(response.statusCode, response.data)
    });
  }

  getNewCustomer(url) {
    const request = new Request();
    request.get(url, (request, response) => {
      handlerStatuscode(response.statusCode, response.data)
    });
  }

  submitCustomer(url) {
    //PEGAR OS VALORES DO FORMULARIO
    let auth_token = document.getElementsByName('authenticity_token')[0].value;
    let name = document.getElementById('customer_name').value;
    let document_number = document.getElementById('customer_document_number').value;
    let params = `authenticity_token=${auth_token}&customer[name]=${name}&customer[document_number]=${document_number}`;

    const request = new Request();
    request.post(url, params, (request, response) => {
      // let data = JSON.parse(response.data);
      Notify.delivery(response.data);
      this.getCustomers('/dashboard/customers');
    });
  }

  submitDepartment(url) {
    //PEGAR OS VALORES DO FORMULARIO
    let auth_token = document.getElementsByName('authenticity_token')[0].value;
    let name = document.getElementById('department_name').value;
    let department_user_id = document.getElementById('department_user_id').value;
    let customers = document.getElementById('department_customer_id');
    const customerId = customers.value;

    if (customerId == "") {
      return window.alert("Select customer");
    }
    let params = `authenticity_token=${auth_token}&department[name]=${name}&department[user_id]=${department_user_id}&department[customer_id]=${customerId}`;
    const request = new Request();
    request.post(url, params, (request, response) => {
      //let data = JSON.parse(response.data);
      Notify.delivery(response.data);
      this.getDepartments('/dashboard/departments');
    });
  }

  getDepartments(url) {
    this.setCurrentPage('departments');
    const request = new Request();
    request.get(url, (request, response) => {
      handlerStatuscode(response.statusCode, response.data)
    });
  }

  getUsers() {
    this.setCurrentPage('users');
    const request = new Request();
    request.get("/dashboard/users", (request, response) => {
      handlerStatuscode(response.statusCode, response.data)
    });
  }

  getUserManager(id) {
    const request = new Request();
    request.get(`/dashboard/users/${id}/manager`, (request, response) => {
      handlerStatuscode(response.statusCode, response.data);
    });
  }

  unlockUser(id, active) {
    const request = new Request();
    request.get(`/dashboard/users/${id}/unlock/${active}`, (request, response) => {
      Notify.delivery(response.data);
      this.getUserManager(id);
    });
  }

  getNewUser() {
    const request = new Request();
    request.get("/dashboard/users/new", (request, response) => {
      handlerStatuscode(response.statusCode, response.data)
    });
  }

  getUser(user_id) {
    const request = new Request();
    request.get(`/dashboard/users/${user_id}/view`, (request, response) => {
      handlerStatuscode(response.statusCode, response.data)
    });
  }

  getAuthorizations(url) {
    this.setCurrentPage('authorizations');

    const request = new Request();
    request.get(url, (request, response) => {
      handlerStatuscode(response.statusCode, response.data)
    });
  }

  getAuthorizationNew(url) {
    const request = new Request();
    request.get(url, (request, response) => {
      handlerStatuscode(response.statusCode, response.data)
    });
  }

  submitAuthorization(url) {
    let auth_token = document.getElementsByName('authenticity_token')[0].value;
    let name = document.getElementById('authorization_name').value;
    let expires_at = document.getElementById('authorization_expires_at').value;
    let user_id = document.getElementById('authorization_user_id').value;
    let program_id = document.getElementById('authorization_program_id').value;
    let params = `authenticity_token=${auth_token}&authorization[name]=${name}&authorization[user_id]=${user_id}&authorization[program_id]=${program_id}&authorization[expires_at]=${expires_at}`;
    const request = new Request();
    request.post(url, params, (request, response) => {
      // let data = JSON.parse(response.data);
      Notify.delivery(response.data);
      this.getAuthorizations('/dashboard/authorizations');
    });

  }

  submitUser(act = 0) {
    //PEGAR OS VALORES DO FORMULARIO
    let auth_token = document.getElementsByName('authenticity_token')[0].value;
    let first_name = document.getElementById('user_first_name').value;
    let last_name = document.getElementById('user_last_name').value;
    let email = document.getElementById('user_email').value;
    let phone = document.getElementById('user_phone').value;
    let params = null;
    if (act == 0) {
      let password_hash = document.getElementById('user_password_hash').value;
      let password_confirmation = document.getElementById('user_password_confirmation').value;
      params = `authenticity_token=${auth_token}&user[first_name]=${first_name}&user[last_name]=${last_name}&user[email]=${email}&user[phone]=${phone}&user[password_hash]=${password_hash}&user[password_confirmation]=${password_confirmation}`;
    }
    let url = '/dashboard/users/create';
    if (act == 1) {
      url = '/dashboard/users/update';
      let userId = document.getElementById('user_id').value;
      params = `authenticity_token=${auth_token}&user[id]=${userId}&user[first_name]=${first_name}&user[last_name]=${last_name}&user[email]=${email}&user[phone]=${phone}`;
    }
    const request = new Request();
    request.post(url, params, (request, response) => {
      // let data = JSON.parse(response.data);
      Notify.delivery(response.data);
      this.getUsers();
    });
  }

  yousure(id) {
    let yousure = document.getElementById('you-sure');
    yousure.classList.add('grid');

    let msgTag = document.getElementById('you-sure-msg');
    msgTag.innerHTML = `Apagar Administrador ${id}, prosseguir?`;

    let btncancel = document.getElementById('btn-cancel');
    btncancel.onclick = function() {
      window.Dashboard.exec_del = false;
      yousure.classList.remove('grid');
    }
    let btnConfirm = document.getElementById('btn-confirm');
    btnConfirm.onclick = function() {
      window.Dashboard.exec_del = true;
      yousure.classList.remove('grid');
      window.Dashboard.admRmv(id);
    }
  }

  yousureToken(id) {
    let yousure = document.getElementById('you-sure');
    yousure.classList.add('grid');

    let msgTag = document.getElementById('you-sure-msg');
    msgTag.innerHTML = `Apagar Token ${id}, prosseguir?`;

    let btncancel = document.getElementById('btn-cancel');
    btncancel.onclick = function() {
      window.Dashboard.exec_del = false;
      yousure.classList.remove('grid');
    }
    let btnConfirm = document.getElementById('btn-confirm');
    btnConfirm.onclick = function() {
      window.Dashboard.exec_del = true;
      yousure.classList.remove('grid');
      window.Dashboard.tokenRmv(id);
    }
  }

  tokenRmv(id) {
    // TEM CERTEZA?
    if (this.exec_del) {
      const request = new Request();
      request.get(`/dashboard/authorizations/${id}/delete`, (request, response) => {
        // let data = JSON.parse(response.data);
        this.getAuthorizations('/dashboard/authorizations');
        Notify.delivery(response.data);
      });
    }
    this.exec_del = false;
  }

  admRmv(id) {
    // TEM CERTEZA?
    if (this.exec_del) {
      const request = new Request();
      request.get(`/dashboard/users/${id}/delete`, (request, response) => {
        // let data = JSON.parse(response.data);
        this.getUsers();
        Notify.delivery(response.data);
      });
    }
    this.exec_del = false;
  }

}
